module.exports = __webpack_public_path__ + "8c23e5bf335b35a88492a33c35502ee7.MP3";